import { Controller } from "@hotwired/stimulus";

// Toggles between light / dark / system themes. Persists the choice in
// a cookie so the server can render the right initial class on the next
// request and avoid a FOUC. Active-button styling is driven by
// aria-pressed; see .theme-btn rules in preferences.html.
export default class extends Controller {
  static targets = ["button"];
  static values = { current: String };

  connect() {
    this.highlight(this.currentValue || "system");
  }

  select(event) {
    const theme = event.currentTarget.dataset.themeName;
    document.cookie = `dora_theme=${theme};path=/;max-age=31536000;SameSite=Lax`;
    const isDark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
    document.documentElement.classList.toggle("dark", isDark);
    this.highlight(theme);
  }

  highlight(theme) {
    this.buttonTargets.forEach((btn) => {
      const active = btn.dataset.themeName === theme;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }
}
